<script>
import APIUser from '@app/services/API/User';
import trainingsMixin from '@app/mixins/trainings';

import CollegeGraduation from '@app/assets/img/advantages/college-graduate.png';
import StoreSupport from '@app/assets/img/advantages/store-support.png';
import ManyDiscounts from '@app/assets/img/advantages/many-discounts.png';
import DataStructure from '@app/assets/img/advantages/data-structure.png';
import Mailing from '@app/assets/img/advantages/mailing.png';
import OnlineUniversities from '@app/assets/img/advantages/online-universities.png';
import DataManipulation from '@app/assets/img/advantages/data-manipulation.png';
import InformationArchive from '@app/assets/img/advantages/information-archive.png';
import WinnerPrize from '@app/assets/img/advantages/winner-prize.png';
import PartnershipAgreement from '@app/assets/img/advantages/partnership-agreement.png';
import BusinessStartup from '@app/assets/img/advantages/business-startup.png';
import SmartAssistant from '@app/assets/img/advantages/smart-assistant.png';
import PeopleManagement from '@app/assets/img/advantages/people-management.png';
import SupportQuestion from '@app/assets/img/advantages/support-question.png';
import StatisticsPresentation from '@app/assets/img/advantages/statistics-presentation.png';

export default {
  mixins: [trainingsMixin],
  computed: {
    authStore() {
      return this.$store.getters['auth/store'];
    },
    isNotPercentPlan() {
      return this.$store.getters['auth/isNotPercentPlan'];
    },
    advantages() {
      return [
        {
          condition: true,
          img: CollegeGraduation,
          text: 'Créer <b>autant de formations</b> que vous le voulez, avec <b>autant d’apprenants</b> que vous le voulez.',
          action: {
            label: 'Ajouter',
            handler: this.addTraining,
          },
        },
        {
          condition: this.isNotPercentPlan && (this.$store.getters['auth/hasProPlan'] || this.$store.getters['auth/hasExpertPlan']),
          img: StoreSupport,
          text: 'Apprendre à créer les meilleures formations en ligne grâce à votre <b>coaching offert</b> !',
          action: {
            label: 'Réserver mon coaching',
            handler: () => {
              window.open(this.$constants.COACHING_URL, '_blank');
            },
          },
        },
        {
          condition: true,
          img: PeopleManagement,
          text: 'Inviter <b>vos collaborateurs</b> à gérer vos contenus et vos apprenants. <b>Passez à la vitesse supérieure !</b>',
          action: {
            label: 'Inviter',
            handler: () => {
              this.$router.push(
                this.$router.resolve({ name: 'settings_team' }).href,
              );
            },
          },
        },
        {
          condition: true,
          img: ManyDiscounts,
          text: 'Créer <b>des codes promo</b> en illimité !',
          action: {
            label: 'Créer',
            handler: () => {
              this.$router.push(this.$router.resolve({ name: 'discounts' }).href);
            },
          },
        },
        {
          condition: true,
          img: DataStructure,
          text: 'Connecter un <b>sous-domaine personnalisé</b>.',
          action: {
            label: 'Connecter',
            handler: () => {
              this.$router.push(this.$router.resolve({ name: 'settings' }).href);
            },
          },
        },
        {
          condition: true,
          img: Mailing,
          text: 'Configurer vos outils marketing parmi <b>Brevo, ActiveCampaign et GetResponse</b>.',
          action: {
            label: 'Configurer',
            handler: () => {
              this.$router.push(
                this.$router.resolve({ name: 'marketing_automations' }).href,
              );
            },
          },
        },
        {
          condition: true,
          img: OnlineUniversities,
          text: '<b>Personnaliser les emails</b> automatiques envoyés à vos apprenants.',
          action: {
            label: 'Personnaliser',
            handler: () => {
              this.$router.push(
                this.$router.resolve({
                  name: 'marketing_emails',
                  query: { onglet: 'WELCOME' },
                }).href,
              );
            },
          },
        },
        {
          condition: true,
          img: DataManipulation,
          text: '<b>Intégrer vos formations</b> sur autant de sites externes que vous le souhaitez.',
          action: {
            label: 'Intégrer',
            handler: () => {
              this.$router.push(
                this.$router.resolve({ name: 'embeds' }).href,
              );
            },
          },
        },
        {
          condition: true,
          img: InformationArchive,
          text: 'Evaluer vos apprenants en <b>leur proposant des devoirs</b> qu’ils devront vous soumettre.',
          action: {
            label: 'Personnaliser',
            handler: () => {
              this.$router.push(
                this.$router.resolve({ name: 'trainings' }).href,
              );
            },
          },
        },
        {
          condition: true,
          img: WinnerPrize,
          text: 'Proposer à vos clients de <b>payer vos formations avec PayPal</b>, pour générer plus de ventes !',
          action: {
            label: 'Connecter',
            handler: () => {
              this.$router.push(
                this.$router.resolve({ name: 'settings_payments' }).href,
              );
            },
          },
        },
        {
          condition: true,
          img: PartnershipAgreement,
          text: 'Configurer <b>un programme d’affiliation complet</b> et faites de vos clients actuels vos <b>apporteurs d’affaire</b>.',
          action: {
            label: 'Configurer',
            handler: () => {
              this.$router.push(
                this.$router.resolve({ name: 'affilates' }).href,
              );
            },
          },
        },
        {
          condition: true,
          img: BusinessStartup,
          text: 'Activer notre <b>système anti-décrochage</b> pour booster le taux de complétion de vos formations.',
          action: {
            label: 'Activer',
            handler: () => {
              this.$router.push(
                this.$router.resolve({
                  name: 'marketing_emails',
                  query: { onglet: 'NO_RECENT_CONNECTION_1' },
                }).href,
              );
            },
          },
        },
        {
          condition: true,
          img: SmartAssistant,
          text: 'Faire appel à nos <b>outils IA</b> pour vous aider à <b>générer du contenu</b> pour vos formations en quelques clics.',
          action: {
            label: 'Générer',
            handler: () => {
              this.$router.push(
                this.$router.resolve({
                  name: 'ai_assistant',
                  query: { type: 'title_ideas' },
                }).href,
              );
            },
          },
        },
        {
          condition: true,
          img: SupportQuestion,
          text: 'Utiliser notre <b>CRM</b> en ajoutant des notes et des informations personnelles sur vos apprenants.',
          action: {
            label: 'Utiliser',
            handler: () => {
              this.$router.push(
                this.$router.resolve({
                  name: 'customers',
                  query: {
                    sort: 'created_at',
                    order: 'desc',
                    type: 'STUDENT',
                    page: 1,
                  },
                }).href,
              );
            },
          },
        },
        {
          condition: this.isNotPercentPlan,
          img: StatisticsPresentation,
          text: 'Récolter <b>des avis à chaud</b> sur chaque leçon pour savoir si vos formations plaisent.',
          action: {
            label: 'Récolter',
            handler: () => {
              this.$router.push(
                this.$router.resolve({ name: 'trainings' }).href,
              );
            },
          },
        },
      ];
    },
  },
  methods: {
    getSupportInfos() {
      if (this.supportData) {
        this.showSupportInfos();
        return;
      }

      const loader = this.$buefy.loading.open();
      APIUser.getSupport()
        .then(({ data }) => this.showSupportInfos(data))
        .finally(() => loader.close());
    },
    showSupportInfos(data) {
      data = this.supportData || data;
      this.supportData = data;
      this.$buefy.dialog.alert(`
        <span class="is-size-4 is-size-5-mobile">
          <strong>Email</strong> : <a href="mailto:${data.email}">${data.email}</a>
        </span>
      `);
    },
    handleClick(advantage) {
      if (advantage.condition !== undefined && !advantage.condition) {
        return this.$showMessage.goPro();
      }

      return advantage.action.handler();
    },
  },
};
</script>

<template>
  <div class="ppacomp">
    <div
      v-for="(advantage, index) in advantages"
      :key="index"
      class="item box p-0"
      >
      <div class="illustration has-custom-background">
        <img :src="advantage.img" />
      </div>

      <p class="text" v-html="advantage.text"/>

      <div class="actions">
        <b-button type="is-flat" @click="handleClick(advantage)" v-bind="advantage.action.attrs" class="custom-button">
          {{ advantage.action.label }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ppacomp {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  @include mobile {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .item {
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    margin-bottom: 1.5rem;

    .illustration {
      margin: 21px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        max-height: 80%;
        max-width: 80%;
      }
    }
    .has-custom-background {
      background: linear-gradient(318.96deg,
        rgba(255, 255, 255, 0.8) 11.46%,
        rgba(255, 255, 255, 0.8) 34.44%,
        rgba(255, 255, 255, 0) 66.52%,
        rgba(255, 255, 255, 0.8) 94.3%,
        rgba(255, 255, 255, 0.8) 94.31%),
        #031815;
      background-blend-mode: multiply;
      border-radius: 20px;
      height: 210px;

    }
    .text {
      margin-right: 30px;
      margin-left: 30px;
    }
    .actions {
      margin-top: auto;
      padding-top: 16px;
      padding-left: 21px;
      padding-right: 21px;
      padding-bottom: 21px;
      text-align: right;
    }
    .custom-button{
      width: 100%;
      border-radius: 22px;
      background: radial-gradient(109.32% 72.43% at 50% 12.35%, #031815 0%, #073C35 100%),
      radial-gradient(75.97% 70.09% at 86.36% 93.51%,
          rgba(208, 208, 208, 0.2) 0%,
          rgba(255, 255, 255, 0) 100%);
      background-blend-mode: multiply;
      color: #fff;
      filter: brightness(1) blur(0);
      transition: 0.5s all 0s;
      border: solid 2px #32c4c0;
      box-shadow: 4px 5px 13px 0px #03181566 !important;
    }
    .custom-button:hover {
      filter: brightness(2) blur(0.5px);
    }
  }
}
</style>
